/**
 * Action name: md_update
 */

export function updateAndDelete() {
	var data = {
		action: 'md_update',
		security: md_object.nonce
	};

	jQuery.ajax({
		data: data,
		beforeSend: () => {
			jQuery('.md-button').attr('disabled', true);
			jQuery('#response').append('<p>Ich aktualisiere...Bitte das Fenster nicht schließen.</p>');
		},
		success: (response) => {
			jQuery('.md-button').attr('disabled', false);

			jQuery('#response').html(response);
			jQuery('#response').append('<p>Erfolgreich.</p>');
		},
		error: (err) => {
			console.log(err);
		}
	});
}
